/**
 * 国际化工具函数
 * 用于处理嵌套对象结构的国际化文件
 */

/**
 * 将嵌套对象展平并添加前缀
 * @param obj 嵌套对象
 * @param prefix 前缀字符串
 * @returns 展平后的键值对对象
 * 
 * @example
 * flattenWithPrefix({ login: { title: 'Login' } }, 'pages.auth')
 * // 返回: { 'pages.auth.login.title': 'Login' }
 */
export function flattenWithPrefix(obj: any, prefix: string = ''): Record<string, string> {
  const result: Record<string, string> = {};
  
  function flatten(current: any, path: string) {
    if (typeof current === 'string') {
      result[path] = current;
    } else if (typeof current === 'object' && current !== null) {
      Object.keys(current).forEach(key => {
        const newPath = path ? `${path}.${key}` : key;
        flatten(current[key], newPath);
      });
    }
  }
  
  flatten(obj, prefix);
  return result;
}

/**
 * 为对象的所有键添加前缀（简单版本）
 * @param prefix 前缀字符串
 * @param obj 扁平的键值对对象
 * @returns 添加前缀后的对象
 * 
 * @example
 * withPrefix('pages.auth', { 'login.title': 'Login' })
 * // 返回: { 'pages.auth.login.title': 'Login' }
 */
export function withPrefix(prefix: string, obj: Record<string, string>): Record<string, string> {
  const result: Record<string, string> = {};
  Object.keys(obj).forEach(key => {
    result[`${prefix}.${key}`] = obj[key];
  });
  return result;
}

/**
 * 类型定义：嵌套的国际化对象
 */
export type NestedI18nObject = {
  [key: string]: string | NestedI18nObject;
};
